<div class="manage-team-dialog-container">
  <div class="modal-header">
    <h2 class="modal-title">{{ data.title }}</h2>
    @if (data.hasClose) {
      <button
        mat-icon-button
        [mat-dialog-close]="false"
        class="close-button"
        aria-label="Close"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>
  <div class="modal-content">
    <app-manage-team [projectId]="data.model.projectId"></app-manage-team>
  </div>
  @if (data.confirmCaption || data.cancelCaption) {
    <div class="modal-actions">
      @if (data.confirmCaption) {
        <button
          mat-stroked-button
          color="primary"
          [mat-dialog-close]="data"
        >
          {{ data.confirmCaption }}
        </button>
      }
      @if (data.cancelCaption) {
        <button mat-stroked-button color="warn" [mat-dialog-close]="false">
          {{ data.cancelCaption }}
        </button>
      }
    </div>
  }
</div>
